import { Component, OnInit, input } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
import { map, takeUntil, tap } from 'rxjs/operators';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { Router } from '@angular/router';
import { ResetStateService } from '@core/services/reset-state.service';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-timer-redirect-block',
  template: ``,
})
export class TimerRedirectBlockComponent extends DestroyerBase implements OnInit {
  readonly redirectTo = input<string>();
  readonly duration = input<number>();
  readonly resetUi = input(false);

  constructor(
    private readonly routerHelper: RouterHelperService,
    private readonly router: Router,
    private readonly resetStateService: ResetStateService,
    private readonly analyticsService: AnalyticsService,
  ) {
    super();
  }

  ngOnInit(): void {
    const duration = this.duration();
    if (!duration || !this.redirectTo()) {
      return;
    }

    timer(duration * 1000)
      .pipe(
        takeUntil(this._destroyerRef),
        tap(() => {
          this.resetUIIfNeeded().subscribe(({ willRedirectToHomePage }) => {
            const redirectTo = this.redirectTo();
            if (!redirectTo || willRedirectToHomePage) {
              return;
            }
            if (this.routerHelper.isLinkExternal(redirectTo)) {
              this.analyticsService.log({
                level: 'debug',
                label: '#DOOD-1250 Navigate',
                message: {
                  from: 'TimerRedirectBlockComponent Ligne°42',
                  target: redirectTo,
                  currentLocation: window.location.pathname,
                },
              });
              window.location.href = redirectTo;
            } else {
              this.analyticsService.log({
                level: 'debug',
                label: '#DOOD-1250 Navigate',
                message: {
                  from: 'TimerRedirectBlockComponent Ligne°52',
                  target: [this.routerHelper.translateRoute(redirectTo)],
                  currentLocation: window.location.pathname,
                },
              });
              this.router.navigate([this.routerHelper.translateRoute(redirectTo)]);
            }
          });
        }),
      )
      .subscribe();
  }

  private resetUIIfNeeded(): Observable<{ willRedirectToHomePage: boolean }> {
    if (this.resetUi()) {
      const redirectTo = this.redirectTo();

      const willRedirectToAnotherPageThanHomePage = redirectTo && redirectTo !== '/';
      return this.resetStateService
        .refreshUI({
          redirectToHomePage: !willRedirectToAnotherPageThanHomePage,
        })
        .pipe(map(() => ({ willRedirectToHomePage: !willRedirectToAnotherPageThanHomePage })));
    }

    return of({ willRedirectToHomePage: false });
  }
}
